module.exports = __webpack_public_path__ + "media/images/expert__mario-gehrer-046da7023c9578eaa96f4b7d0e670808.png";